export default __webpack_public_path__ + "static/media/cs-a009-2.c2590067.svg";